/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Action_Sales_ReturnInputs */

const vi_order_action_sales_return = /** @type {(inputs: Order_Action_Sales_ReturnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trả hàng`)
};

/**

* @param {Order_Action_Sales_ReturnInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_action_sales_return = /** @type {((inputs?: Order_Action_Sales_ReturnInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Action_Sales_ReturnInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_action_sales_return(inputs)
});